import { avatarSlotFor } from '../../../lib/avatar-color';
import { Avatar } from '../ui/Avatar';

/**
 * The avatar on a connected account's row (Figma: Symphony → Connectors, the accounts nested under a
 * connected connector, and the disconnect dialog). 32px, the DS size the design uses.
 *
 * It renders the shared `Avatar`, so its colour now comes off the DS `--ds-avatar-*` ramp. It used to
 * carry a hand-picked six-entry palette of tokens borrowed from unrelated roles (`--ds-pink-400`,
 * `--ds-badge-fill-in-progress`, `--ds-badge-fill-agents-group`, …), which meant a connector account and a
 * referral row could paint the same person two different colours, and one of those colours was a BADGE
 * fill doing duty as an identity.
 */
export function AccountAvatar({ label }: { label: string }) {
  return <Avatar initials={accountInitials(label)} size={32} color={avatarSlotFor(label)} />;
}

/**
 * Initials for an account LABEL, which is normally an email — so the local part is what carries the name
 * and its separators are word breaks: `anna.rossi@host` → "AR". Distinct from the shared display-name
 * derivation for exactly that reason.
 */
function accountInitials(label: string): string {
  const local = label.split('@')[0]?.replace(/[._-]+/g, ' ').trim() ?? '';
  const words = local.split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0]![0]! + words[1]![0]!).toUpperCase();
  if (words[0]) return words[0]!.slice(0, 1).toUpperCase();
  return (label.trim()[0] ?? '?').toUpperCase();
}
